import { Document, Font, Page, StyleSheet, View } from "@react-pdf/renderer";
import React from "react";
import { PDFFooter } from "./PDFFooter";
import { PDFHeader } from "./PDFHeader";

// Stylesheet for PDFDocument
const documentStyles = StyleSheet.create({
    container: {
        fontFamily: "Poppins",
        padding: 5,
        marginBottom: 5
    },
});

// Stylesheet for PDFPage
const pageStyles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 30,
        paddingRight: 30,
        color: "black"
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        flexGrow: 1
    },
    cell1: {
        width: "40%", // Adjust based on your layout
        paddingTop: 15
    },
    cell2: {
        width: "56%", // Adjust based on your layout
        paddingTop: 30,
        paddingBottom: 30,
        paddingLeft: 0,
        paddingRight: 0
    },
});

// Register fonts (assuming these are declared globally)
Font.register({ family: "Poppins", src: `/font/Poppins-Regular.ttf` });
Font.register({ family: "Poppins-Medium", src: `/font/Poppins-Medium.ttf` });
Font.register({ family: "Poppins-Bold", src: `/font/Poppins-Bold.ttf` });
Font.register({ family: "PDF-Hebrew", src: `/font/NotoSansHebrew-Variable.ttf` });
Font.registerHyphenationCallback((word) => [word]);

// Interface for PDFDocument props
interface PDFDocumentProps {
    children?: React.ReactNode;
    onRender?: () => void;
    title?: string;
}

// PDFDocument component
export const PDFDocument: React.FC<PDFDocumentProps> = ({ children, onRender, title }) => {
    return (
        <Document style={documentStyles.container} onRender={onRender} title={title}>
            {children}
        </Document>
    );
};

// Interface for PDFPage props
interface PDFPageProps {
    children?: React.ReactNode;
    logo_path?: string;
    footer?: boolean;
    header_title?: string;
    anchorId?: string; // named destination for internal links to the top of this page
}

// PDFPage component
export const PDFPage: React.FC<PDFPageProps> = ({ children, logo_path, footer, header_title, anchorId }) => {
    return (
        <Page size="A4" style={pageStyles.page} orientation="landscape">
            {anchorId && <View id={anchorId} />}
            {header_title && <PDFHeader logo_path={logo_path} title={header_title} />}
            {children}
            {footer && <PDFFooter />}
        </Page>
    );
};

